"use strict";

var ws = void 0;

if (typeof WebSocket !== "undefined") {
	ws = WebSocket;
} else if (typeof MozWebSocket !== "undefined") {
	ws = MozWebSocket;
} else {
	ws = window.WebSocket || window.MozWebSocket;
}

module.exports = ws;


//////////////////
// WEBPACK FOOTER
// ./node_modules/appbase-js/lib/ws-shim.js
// module id = 193
// module chunks = 0